"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { SiteShell } from "@/components/site-shell";
import { getDictionary, localePath, sectionPagePath, type Locale } from "@/lib/i18n";

function localeFromPath(pathname: string): Locale {
  return pathname.startsWith("/en") ? "en" : "tr";
}

export function NotFoundPage() {
  const pathname = usePathname() ?? "";
  const locale = localeFromPath(pathname);
  const d = getDictionary(locale);
  const nf = d.notFound;

  return (
    <SiteShell locale={locale}>
      <section
        aria-labelledby="not-found-heading"
        className="border-b border-border px-6 py-20 sm:py-28"
      >
        <div className="mx-auto max-w-5xl">
          <p
            className="select-none font-thin text-[clamp(3.75rem,13vw,8.5rem)] leading-[0.95] tracking-tight text-foreground/[0.14]"
            aria-hidden
          >
            {nf.code}
          </p>
          <h1
            id="not-found-heading"
            className="mt-2 max-w-2xl font-thin text-3xl leading-tight tracking-tight sm:text-4xl md:text-5xl"
          >
            {nf.title}
          </h1>
          <p className="mt-6 max-w-xl text-base font-medium leading-relaxed text-muted">
            {nf.description}
          </p>
          <div className="mt-10 flex flex-wrap gap-4">
            <Link
              href={localePath(locale)}
              className="inline-flex items-center justify-center rounded-full bg-[#F97316] px-8 py-3 text-sm font-medium text-[#172554] transition-opacity hover:opacity-90"
            >
              {nf.ctaHome}
            </Link>
            <Link
              href={sectionPagePath(locale, "contact")}
              className="inline-flex items-center justify-center rounded-full border border-border px-8 py-3 text-sm font-medium transition-colors hover:bg-card"
            >
              {nf.ctaContact}
            </Link>
          </div>
        </div>
      </section>
    </SiteShell>
  );
}
